const { createConstant } = require('../helpers')

const service = 'setting-service'

module.exports = {
  GET_CAMPAIGN_LIST: createConstant(service, 'GET_CAMPAIGN_LIST'),
  GET_CAMPAIGN_LIST_SUCCESS: createConstant(service, 'GET_CAMPAIGN_LIST_SUCCESS'),
  GET_CAMPAIGN_LIST_ERROR: createConstant(service, 'GET_CAMPAIGN_LIST_ERROR'),
  GET_CAMPAIGN_LIST_RESET: createConstant(service, 'GET_CAMPAIGN_LIST_RESET'),

  CREATE_CAMPAIGN: createConstant(service, 'CREATE_CAMPAIGN'),
  CREATE_CAMPAIGN_SUCCESS: createConstant(service, 'CREATE_CAMPAIGN_SUCCESS'),
  CREATE_CAMPAIGN_ERROR: createConstant(service, 'CREATE_CAMPAIGN_ERROR'),
  CREATE_CAMPAIGN_RESET: createConstant(service, 'CREATE_CAMPAIGN_RESET'),

  UPDATE_CAMPAIGN: createConstant(service, 'UPDATE_CAMPAIGN'),
  UPDATE_CAMPAIGN_SUCCESS: createConstant(service, 'UPDATE_CAMPAIGN_SUCCESS'),
  UPDATE_CAMPAIGN_ERROR: createConstant(service, 'UPDATE_CAMPAIGN_ERROR'),
  UPDATE_CAMPAIGN_RESET: createConstant(service, 'UPDATE_CAMPAIGN_RESET'),

  DELETE_CAMPAIGN: createConstant(service, 'DELETE_CAMPAIGN'),
  DELETE_CAMPAIGN_SUCCESS: createConstant(service, 'DELETE_CAMPAIGN_SUCCESS'),
  DELETE_CAMPAIGN_ERROR: createConstant(service, 'DELETE_CAMPAIGN_ERROR'),
  DELETE_CAMPAIGN_RESET: createConstant(service, 'DELETE_CAMPAIGN_RESET'),

  GET_ROUTE_LIST: createConstant(service, 'GET_ROUTE_LIST'),
  GET_ROUTE_LIST_SUCCESS: createConstant(service, 'GET_ROUTE_LIST_SUCCESS'),
  GET_ROUTE_LIST_ERROR: createConstant(service, 'GET_ROUTE_LIST_ERROR'),
  GET_ROUTE_LIST_RESET: createConstant(service, 'GET_ROUTE_LIST_RESET'),

  CREATE_ROUTE: createConstant(service, 'CREATE_ROUTE'),
  CREATE_ROUTE_SUCCESS: createConstant(service, 'CREATE_ROUTE_SUCCESS'),
  CREATE_ROUTE_ERROR: createConstant(service, 'CREATE_ROUTE_ERROR'),
  CREATE_ROUTE_RESET: createConstant(service, 'CREATE_ROUTE_RESET'),

  UPDATE_ROUTE: createConstant(service, 'UPDATE_ROUTE'),
  UPDATE_ROUTE_SUCCESS: createConstant(service, 'UPDATE_ROUTE_SUCCESS'),
  UPDATE_ROUTE_ERROR: createConstant(service, 'UPDATE_ROUTE_ERROR'),
  UPDATE_ROUTE_RESET: createConstant(service, 'UPDATE_ROUTE_RESET'),

  DELETE_ROUTE: createConstant(service, 'DELETE_ROUTE'),
  DELETE_ROUTE_SUCCESS: createConstant(service, 'DELETE_ROUTE_SUCCESS'),
  DELETE_ROUTE_ERROR: createConstant(service, 'DELETE_ROUTE_ERROR'),
  DELETE_ROUTE_RESET: createConstant(service, 'DELETE_ROUTE_RESET'),

  DO_TEST_AUDIO_CALL: createConstant(service, 'DO_TEST_AUDIO_CALL'),
  DO_TEST_AUDIO_CALL_SUCCESS: createConstant(service, 'DO_TEST_AUDIO_CALL_SUCCESS'),
  DO_TEST_AUDIO_CALL_ERROR: createConstant(service, 'DO_TEST_AUDIO_CALL_ERROR'),
  DO_TEST_AUDIO_CALL_RESET: createConstant(service, 'DO_TEST_AUDIO_CALL_RESET'),

  GET_PRIORITY_TEAM_LIST: createConstant(service, 'GET_PRIORITY_TEAM_LIST'),
  GET_PRIORITY_TEAM_LIST_SUCCESS: createConstant(service, 'GET_PRIORITY_TEAM_LIST_SUCCESS'),
  GET_PRIORITY_TEAM_LIST_ERROR: createConstant(service, 'GET_PRIORITY_TEAM_LIST_ERROR'),
  GET_PRIORITY_TEAM_LIST_RESET: createConstant(service, 'GET_PRIORITY_TEAM_LIST_RESET'),

  GET_PRIORITY_TEAM_DETAIL: createConstant(service, 'GET_PRIORITY_TEAM_DETAIL'),
  GET_PRIORITY_TEAM_DETAIL_SUCCESS: createConstant(service, 'GET_PRIORITY_TEAM_DETAIL_SUCCESS'),
  GET_PRIORITY_TEAM_DETAIL_ERROR: createConstant(service, 'GET_PRIORITY_TEAM_DETAIL_ERROR'),
  GET_PRIORITY_TEAM_DETAIL_RESET: createConstant(service, 'GET_PRIORITY_TEAM_DETAIL_RESET'),

  CREATE_PRIORITY_TEAM: createConstant(service, 'CREATE_PRIORITY_TEAM'),
  CREATE_PRIORITY_TEAM_SUCCESS: createConstant(service, 'CREATE_PRIORITY_TEAM_SUCCESS'),
  CREATE_PRIORITY_TEAM_ERROR: createConstant(service, 'CREATE_PRIORITY_TEAM_ERROR'),
  CREATE_PRIORITY_TEAM_RESET: createConstant(service, 'CREATE_PRIORITY_TEAM_RESET'),

  UPDATE_PRIORITY_TEAM: createConstant(service, 'UPDATE_PRIORITY_TEAM'),
  UPDATE_PRIORITY_TEAM_SUCCESS: createConstant(service, 'UPDATE_PRIORITY_TEAM_SUCCESS'),
  UPDATE_PRIORITY_TEAM_ERROR: createConstant(service, 'UPDATE_PRIORITY_TEAM_ERROR'),
  UPDATE_PRIORITY_TEAM_RESET: createConstant(service, 'UPDATE_PRIORITY_TEAM_RESET'),

  ADD_DOCTOR_TO_PRIORITY_TEAM: createConstant(service, 'ADD_DOCTOR_TO_PRIORITY_TEAM'),
  ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS: createConstant(service, 'ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS'),
  ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR: createConstant(service, 'ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR'),
  ADD_DOCTOR_TO_PRIORITY_TEAM_RESET: createConstant(service, 'ADD_DOCTOR_TO_PRIORITY_TEAM_RESET'),

  DELETE_PRIORITY_TEAM: createConstant(service, 'DELETE_PRIORITY_TEAM'),
  DELETE_PRIORITY_TEAM_SUCCESS: createConstant(service, 'DELETE_PRIORITY_TEAM_SUCCESS'),
  DELETE_PRIORITY_TEAM_ERROR: createConstant(service, 'DELETE_PRIORITY_TEAM_ERROR'),
  DELETE_PRIORITY_TEAM_RESET: createConstant(service, 'DELETE_PRIORITY_TEAM_RESET'),
}
